import Navigation1 from "../components/Navigation1";
import { Container } from '@/components/ui/container';
import { Stack, Inline } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';
import DarkFooter from "../components/DarkFooter";

const AfterGetStartedOnScreeningTest = () => {
  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-background">
      <img
        className="absolute inset-0 w-full h-full object-cover opacity-20 z-0"
        alt=""
        src="/rectangle-38421@2x.png"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-background z-0" />
      <img
        className="absolute top-0 left-0 w-full h-auto opacity-10 z-0"
        alt=""
        src="/grid-top-zero-height@2x.png"
      />
      
      <div className="relative z-10">
        <Navigation1 />
        <DarkFooter />
        
        <Container>
          <Stack spacing="lg" align="center" className="text-center py-12 my-8">
            <Heading level="h2" className="text-3xl md:text-4xl font-bold">
              Customize Your Screening Test
            </Heading>
            <Text size="lg" variant="muted" className="max-w-2xl">
              Select your preferred topic, difficulty level, and schedule to
              create a test experience tailored to your needs.
            </Text>
          </Stack>
        </Container>
        
        <footer className="bg-muted/30 border-t border-border py-8 mt-16">
          <Container>
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="flex items-center gap-6">
                <Text className="font-semibold">Logo</Text>
                <Inline spacing="md" className="text-sm text-muted-foreground">
                  <a href="#home" className="hover:text-foreground transition-colors">Home</a>
                  <a href="#about" className="hover:text-foreground transition-colors">About</a>
                  <a href="#faq" className="hover:text-foreground transition-colors">FAQ</a>
                  <a href="#testimonial" className="hover:text-foreground transition-colors">Testimonial</a>
                  <a href="#contact" className="hover:text-foreground transition-colors">Contact</a>
                </Inline>
              </div>
              <Text variant="muted" className="text-sm">
                © 2023 <strong>Company Name</strong>. All Rights Reserved.
              </Text>
            </div>
          </Container>
        </footer>
      </div>
    </div>
  );
};

export default AfterGetStartedOnScreeningTest;